// Help shown beside a filter's name in the filter dialog. A filter config can
// carry its own "tooltip" text; the ping status filter explains online/offline
// by default so it matches the dots it filters on.
export const PING_STATUS_FILTER_KEY = "pingStatus";

export const resolveFilterTooltip = (filter) => {
  const text = typeof filter?.tooltip === "string" ? filter.tooltip.trim() : "";
  if (text) return { type: "text", text };
  if (filter?.key === PING_STATUS_FILTER_KEY) return { type: "pingStatus" };
  return null;
};
